module.exports = __webpack_public_path__ + "img/post_13.cffc0987.png";